import { useEffect, useState } from "react";

/**
 * Seconds left, counting down once a second from what the server reported (`seconds`), so a
 * device clock that is off doesn't skew it. Restarts whenever `seconds` or `restartKey` changes
 * (a fresh server value); null while there is nothing to count.
 */
export function useCountdown(seconds: number | null | undefined, restartKey?: unknown): number | null {
  const [left, setLeft] = useState<number | null>(seconds ?? null);
  useEffect(() => {
    if (seconds === null || seconds === undefined) {
      setLeft(null);
      return;
    }
    const started = Date.now(); // only differences are used: clock skew cancels out
    setLeft(seconds);
    const timer = setInterval(() => {
      const next = Math.max(0, seconds - Math.floor((Date.now() - started) / 1000));
      setLeft(next);
      if (next === 0) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
  }, [seconds, restartKey]);
  return left;
}

/** 272 → "4:32". */
export function formatCountdown(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}
